import React, { createElement, Fragment } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import usePortal from "react-useportal";
// libs:
import xmljs from "xml-js";

// My components:
import {
  Br, Div, Span, Container, Label, Icon, Etext, Badge, Divider, Space, Flex, Tabs, Accordions, Grid, Form, Input, ButtonsGroup, Button, FloatButton,
  Steps, Cascader, Checkbox, Radio, DatePicker, Select, Segmented, Switch, Transfer, Avatar, Link, Calendar, Modal, AGgrid, Upload, Image, Tree,
  List, Canvas, Chart, Iframe, ReactGridLayout, UserStyle, Jodit, HTMLMDviewer, Drawer, Docviewer, Approval, Chat, GuacamoleViewer
} from "../components/ui";

// Redux-hooks:
import { useAppSelector } from "./redux-hooks.ts";
// Reducers:
import { getAppJSON } from "./reducer.ts";

// Types:
import type Iuigen from "../types/Iuigen.d.ts";
import type {TelementJSON, TallElements, TjsonConstructorProps, TuniversalElementProps} from "../types/Iuigen.d.ts";
import type {TelementState, TuiState} from "../types/uiapp.d.ts";

const { rz } = window;

const uigen:Iuigen = {
  ConvertXMLtoJSON: (xml) => {
    const ans:TallElements = {result: false, err: "", namespace: ""};
    let jsnt;
    try { jsnt = xmljs.xml2js(xml, {compact: false}) }
    catch (err) { ans.err = rz.errToString(err); return ans }
    // eslint-disable-next-line max-len
    if (!jsnt || !jsnt.elements || !jsnt.elements[0] || !jsnt.elements[0].attributes?.key || !jsnt.elements[0].name || jsnt.elements[0].name !== "template") { ans.err = "Incorrect xml-template. It must be started as\n<template key='...' type='...' title_en='...' title_ru='...'> ... </template>"; return ans }
    ans.rootAttributes = jsnt.elements[0].attributes;
    ans.elements = jsnt.elements[0].elements;
    ans.namespace = ans.rootAttributes?.key;
    if (!ans.rootAttributes || !ans.rootAttributes.key || !ans.rootAttributes.type) { ans.err = "Root element must have at least 2 attributes: 'key', 'type'"; return ans }
    if (!rz.arrContains(["page", "widget"], ans.rootAttributes.type)) { ans.err = "Unknown template.type '" + ans.rootAttributes.type + "'. React-constructor doesn't know how to build it."; return ans }
    if (!ans.elements || !ans.elements.length) { ans.err = "Empty template.elements"; return ans }
    ans.jsn = jsnt;
    // Generate flat state:
    ans.result = true; return ans;
  },

  buildUIstate: (elements, rootAttributes) => {
    const ans:TuiState = {};
    // const rootNamespace = window[rootElement.attributes.key];

    const buildFlatState = (parseElements:TelementJSON[], parentPath?:string) => {
      if (parseElements && parseElements.length) {
        parseElements.forEach((nextEl, i) => {
          if (nextEl && nextEl.name && nextEl.type) {
            if (nextEl.type === "element") {
              const curPath = (nextEl?.attributes?.key ? nextEl.attributes.key : nextEl.name + (!rz.arrContains(["en", "ru", "tr"], nextEl.name) ? "[" + i + "]" : ""));
              const fullPath = (parentPath ? parentPath + "/" : "") + curPath;
              const fltSt:TelementState = {
                key: nextEl.attributes?.key, name: nextEl.name, shortPath: curPath, fullPath,
                userStyle: (nextEl.attributes && nextEl.attributes.style ? rz.parseCSSText(nextEl.attributes.style) : {}),
                userClass: rz.arrGetUnique((nextEl.attributes?.class || "").split(" "), true, true, true),
                attributes: {rootAttributes}
              };
              // Special Elements Definitions
              if (nextEl.name === "aggrid") {
                fltSt.data = []; fltSt.loading = true; fltSt.specialParams = {columnDefs: (new Date()).getTime()};
              }
              if (nextEl.name === "canvas") {
                fltSt.data = []; fltSt.loading = true; fltSt.specialParams = {rendered: (new Date()).getTime()};
              }
              if (nextEl.name === "chart" || nextEl.name === "chartjs") {
                fltSt.data = []; fltSt.loading = true;
              }
              if (rz.arrContains(["list", "approval", "chat"], nextEl.name)) {
                fltSt.data = [];
              }
              else if (nextEl.name === "upload") {
                fltSt.value = [];
              }
              else if (nextEl.name === "image") {
                fltSt.items = [];
              }
              else if (~["tabs", "accordions", "steps", "segmented"].indexOf(nextEl.name)) {
                const vlu = nextEl.attributes?.value || (nextEl.elements && nextEl.elements[0] && nextEl.elements[0].attributes?.key);
                if (vlu) { fltSt.value = vlu }
              }
              else if (nextEl.name === "style" || nextEl.name === "docviewer") {
                fltSt.value = "";
                // Detect text inside <style>...</style>
                const texts = (nextEl.elements || []).filter((el1:TelementJSON) => (el1?.type === "text")).map((el1:TelementJSON) => (el1?.text || ""));
                if (texts && texts[0]) { fltSt.value = texts[0] }
              }

              // Parse Attributes
              if (nextEl.attributes) {
                fltSt.attributes = {...nextEl.attributes, rootAttributes}; // rz.objDeleteKeys(nextEl.attributes, ["value", "visible", "disabled", "loading", "style", "class"]);
                const attrKeys = (rz.isObject(nextEl.attributes) && rz.objKeys(nextEl.attributes)) || [];
                // Optional attributes:
                if (~attrKeys.indexOf("value")) {
                  const v1 = nextEl.attributes.value;
                  if (rz.isString(v1) && v1.startsWith("{") && v1.endsWith("}")) { const jsnb = (rz.strReplaceAll(v1, "'", "\"")).trim(); let jsn; try { jsn = JSON.parse(jsnb) } catch (err) { console.log(err) } fltSt.value = jsn || v1 }
                  else if (nextEl.name === "switch") { fltSt.value = (v1 === "true") }
                  else { fltSt.value = v1 }
                }
                if (~attrKeys.indexOf("items") || ~attrKeys.indexOf("options")) {
                  const v1 = nextEl.attributes.items || nextEl.attributes.options;
                  if (v1 && rz.isString(v1)) {
                    if (v1.startsWith("{") && v1.endsWith("}")) {
                      const jsnb = (rz.strReplaceAll(v1, "'", "\"")).trim(); let jsn; try { jsn = JSON.parse(jsnb) } catch (err) { console.log(err) }
                      if (jsn?.items && rz.isArray(jsn.items)) { fltSt.items = jsn.items }
                      else if (jsn?.options && rz.isArray(jsn.options)) { fltSt.items = jsn.options }
                    } else { fltSt.items = v1.split("|").map((value) => ({value})) }
                  }
                }
                if (~attrKeys.indexOf("status")) { fltSt.status = nextEl.attributes.status }
                if (~attrKeys.indexOf("visible") && ~["true", "false"].indexOf(nextEl.attributes.visible)) { fltSt.visible = (nextEl.attributes.visible === "true") }
                else if (~attrKeys.indexOf("hidden") && ~["true", "false"].indexOf(nextEl.attributes.hidden)) { fltSt.visible = (nextEl.attributes.hidden === "false") }
                else if (rz.arrContains(["modal", "drawer", "offcanvas"], nextEl.name)) { fltSt.visible = Boolean(nextEl.attributes?.visible === "true") }
                else { fltSt.visible = true } // Default
                if (~attrKeys.indexOf("disabled") && ~["true", "false"].indexOf(nextEl.attributes.disabled)) { fltSt.disabled = (nextEl.attributes.disabled === "true") }
                else if (~attrKeys.indexOf("enabled") && ~["true", "false"].indexOf(nextEl.attributes.enabled)) { fltSt.disabled = (nextEl.attributes.enabled === "false") }
                else { fltSt.disabled = false } // Default
                if (~attrKeys.indexOf("loading") && nextEl.attributes.loading === "true") { fltSt.loading = true }
                // else { fltSt.loading = false } // Default
              }
              else {
                fltSt.attributes = {rootAttributes}
              }

              ans[fullPath] = fltSt;
              // Children-elements
              if (nextEl.elements && nextEl.elements.length) { buildFlatState(nextEl.elements, fullPath) }
            }
          }
        });
      }
    };
    // ----------------------------------
    buildFlatState(elements);
    // ----------------------------------
    return ans;
  },

  GeneratePage: ({rootAttributes}:TjsonConstructorProps) => {
    const appJSON = useAppSelector(getAppJSON(rootAttributes?.key));
    // console.log({action: "uigen.GeneratePage('" + (rootAttributes?.key || "") + "')", appJSON});
    if (!appJSON || !rz.isArray(appJSON)) { return (<Fragment key={(rootAttributes?.key || "") + "-generation-page-error"} />) }
    const page = uigen.GenerateNextUIelement({rootAttributes, currentElementJSON: (appJSON as TelementJSON[])});
    return page;
  },

  buildSubContent: (elements, fullPathItem, jsonPathItem) => ((elements || []).map((el2:TelementJSON, j:number) => {
    const key:string = (el2.attributes?.key || (el2.name + (!~["en", "ru", "tr"].indexOf(el2.name) ? "[" + j + "]" : "")));
    const fullPath = fullPathItem + "/" + key;
    const jsonPath = (jsonPathItem || "") + ".elements[" + j + "]";
    const content = uigen.buildSubContent(el2.elements as TelementJSON[], fullPath, jsonPath);
    return {key, fullPath, jsonPath, attributes: el2?.attributes, name: el2.name, type: el2.type, content};
  })),

  GenerateNextUIelement: ({rootAttributes, currentElementJSON, ikey, parentPath, parentJSONpath}:TjsonConstructorProps) => {
    if (!currentElementJSON) return (<Fragment key={ikey} />);
    const isRootElement = Boolean(parentPath);
    if (currentElementJSON.constructor === Array) {
      return (<Fragment key={parentPath || ikey}>{
        // @ts-ignore
        currentElementJSON.map((iElement:TelementJSON, i:number) => {
          const fullPath = (!parentPath ? "" : (parentPath + (iElement?.attributes?.key || (iElement.name + (!~["en", "ru", "tr"].indexOf(iElement.name) ? "[" + i + "]" : "")))));
          const jsonPath = (parentJSONpath ? ".elements[" + i + "]" : "");
          return uigen.GenerateNextUIelement({rootAttributes, currentElementJSON: iElement, ikey: (isRootElement ? undefined : i), parentPath: (isRootElement ? parentPath : fullPath), parentJSONpath: jsonPath})
        })
      }</Fragment>);
    }

    const attributes:{[key:string]:any} = rz.objClone((currentElementJSON as TelementJSON).attributes || {});
    attributes.name = (currentElementJSON as TelementJSON).name;
    attributes.rootAttributes = rootAttributes;
    attributes.fullPath = (parentPath ? parentPath + "/" : "") + (attributes?.key || (attributes.name + (!~["en", "ru", "tr"].indexOf(attributes.name) ? "[" + (ikey || ikey === 0 ? ikey : 0) + "]" : "")));
    attributes.jsonPath = (parentJSONpath || "") + (ikey || ikey === 0 ? ".elements[" + ikey + "]" : "");
    if (!attributes.key && attributes.key !== 0) { attributes.key = attributes.name + (!~["en", "ru", "tr"].indexOf(attributes.name) ? "[" + (ikey || ikey === 0 ? ikey : 0) + "]" : "") }
    // Debug:
    // if (attributes.key === "cf-tabs") { console.log({_: "► GenerateNextUIelement('" + attributes.key + "')", ikey, attributes_key: attributes.key, parentPath, fullPath: attributes.fullPath, parentJSONpath, jsonPath: attributes.jsonPath}) }

    let children:Array<React.ReactElement | string> = [];
    if ((currentElementJSON as TelementJSON).elements) {
      // Detect language tags <ru> | <en> instead title_en | title_ru
      attributes.texts = (currentElementJSON as TelementJSON).elements!.filter((el1:TelementJSON) => (el1?.type === "element" && ~["ru", "en", "tr"].indexOf(el1?.name) && el1?.elements))
        .map((el1:TelementJSON) => ({text: el1.elements![0].text || "", lng: el1?.name})); // Texts blocks: <ru> | <en>
      const ien = rz.arrFindObj(attributes.texts, {lng: "en"}); if (~ien) { attributes.title_en = attributes.texts[ien].text }
      const iru = rz.arrFindObj(attributes.texts, {lng: "ru"}); if (~iru) { attributes.title_ru = attributes.texts[iru].text }
      const itr = rz.arrFindObj(attributes.texts, {lng: "tr"}); if (~itr) { attributes.title_tr = attributes.texts[itr].text }

      // At first we must build all sub-elements jsonPaths
      const elementsJSONpaths = (currentElementJSON as TelementJSON).elements?.map((el1, i) => ({
        fullPath: attributes.fullPath + "/" + (el1.attributes?.key || (el1.name + (!~["en", "ru", "tr"].indexOf(el1.name) ? "[" + i + "]" : ""))),
        jsonPath: attributes.jsonPath + ".elements[" + i + "]"
      }));

      // Detect special content inside Tab | Cell | Menu | Accordion | Step | Items
      // For Menu - 2 levels of nesting is allowed:
      if (~["button", "menu", "cascader", "select", "segmented", "transfer", "tree"].indexOf(attributes.name)) {
        // Example: <button><item>...</item><item><item>...</item><item>...</item></item></button>  - Button with Menu and submenu
        // Detect DropdownMenu Items
        attributes.content = (currentElementJSON as TelementJSON).elements!.filter((el1:TelementJSON) => (el1?.type === "element" && ~["item", "option"].indexOf(el1?.name) && el1?.attributes))
          .map((el1:TelementJSON, i:number) => { // Dropdown Menu Items
            const itemkey = (el1.attributes?.key || (el1.name + (!~["en", "ru", "tr"].indexOf(el1.name) ? "[" + i + "]" : "")));
            const fullPathItem = attributes.fullPath + "/" + itemkey;
            const jsonPathItem = (elementsJSONpaths?.find((jp) => (jp.fullPath === fullPathItem)))?.jsonPath || ((parentJSONpath || "") + ".elements[" + i + "]");
            const subContent = uigen.buildSubContent(el1.elements as TelementJSON[], fullPathItem, jsonPathItem);
            return {key: itemkey, fullPath: fullPathItem, jsonPath: jsonPathItem, attributes: el1?.attributes, content: subContent};
          });
        if (attributes.content && attributes.content.length) { attributes.hasitems = true }
      }
      else if (~["tabs", "accordions", "grid", "reactgridlayout", "ReactGridLayout", "reactGridLayout", "steps", "checkbox", "radio", "calendar"].indexOf(attributes.name)) { // For other element types - Only 1 level of nesting is allowed !!!
        // Example: <tabs><tab>...</tab><tab>...</tab></tabs>
        attributes.content = (currentElementJSON as TelementJSON).elements!.filter((el1:TelementJSON) => (el1?.type === "element" && ~["tab", "accordion", "cell", "step", "item", "option"].indexOf(el1?.name)))
          .map((el1:TelementJSON, i:number) => { // Tabs
            const itemkey = (el1.attributes?.key || (el1.name + (!~["en", "ru", "tr"].indexOf(el1.name) ? "[" + i + "]" : "")));
            const fullPathItem = attributes.fullPath + "/" + itemkey;
            const jsonPath = (elementsJSONpaths?.find((jp) => (jp.fullPath === fullPathItem)))?.jsonPath || (attributes.jsonPath + ".elements[" + i + "]");
            // Debug
            // if (itemkey === "cf-tab2") { console.log("!!!!!!!!", {jsonPath, attributes_jsonPath: attributes.jsonPath, elementsJSONpaths, parentJSONpath}) }
            const content = (el1.elements || []).map((el2:TelementJSON, j:number) => {
              const contentkey = (el2.attributes?.key || (el2.name + (!~["en", "ru", "tr"].indexOf(el2.name) ? "[" + j + "]" : "")));
              const fullPathContent = fullPathItem + "/" + contentkey;
              const jsonPathContent = (jsonPath || ""); // + ".elements[" + j + "]"
              const subChildren = uigen.GenerateNextUIelement({rootAttributes, currentElementJSON: el2, ikey: j, parentPath: fullPathItem, parentJSONpath: jsonPathContent});
              return {key: contentkey, fullPath: fullPathContent, attributes: el2?.attributes, children: subChildren};
            });
            return {key: itemkey, fullPath: fullPathItem, jsonPath, attributes: el1?.attributes, content};
          });
        if (attributes.content && attributes.content.length) { attributes.hasitems = true }
      }
      else if (attributes.name === "modal") {
        (currentElementJSON as TelementJSON).elements!.forEach((el1:TelementJSON, i:number) => {
          if (el1?.type === "element" && el1?.name === "footer" && el1?.elements?.length) {
            const footerkey = (el1.attributes?.key || (el1.name + (!~["en", "ru", "tr"].indexOf(el1.name) ? "[" + i + "]" : "")));
            attributes.footer = el1.elements
              .filter((el2) => (~["button"].indexOf(el2?.name))) // Only buttons are allowed inside a modal footer!
              .map((el2:TelementJSON, j:number) => {
                const itemkey = (el2.attributes?.key || (el2.name + (!~["en", "ru", "tr"].indexOf(el2.name) ? "[" + j + "]" : "")));
                const fullPathItem = attributes.fullPath + footerkey + "/" + itemkey;
                const prntJsonPath = (elementsJSONpaths?.find((jp) => (jp.fullPath === fullPathItem)))?.jsonPath || (attributes.jsonPath + ".elements[" + i + "]");
                return uigen.GenerateNextUIelement({
                  rootAttributes, currentElementJSON: el2, ikey: j, parentPath: fullPathItem, parentJSONpath: prntJsonPath
                });
              });
          }
        });
      }

      // Other components (can have any content direct inside them)
      children = (currentElementJSON as TelementJSON).elements!.filter(
        (el1:TelementJSON) => (
          (el1?.type === "element" && !~["ru", "en", "tr", "tab", "accordion", "cell", "step", "item", "option", "modal", "header", "footer"].indexOf(el1?.name))
          || (el1?.type === "text")
        )
      ).map((el1:TelementJSON, i:number) => (
        el1?.type === "text" ? (el1.text as string)
          : uigen.GenerateNextUIelement({
            rootAttributes, currentElementJSON: el1, ikey: i, parentPath: attributes.fullPath, parentJSONpath: attributes.jsonPath
          })
      ));
    }

    const props:TuniversalElementProps = {attributes, key: attributes.key};

    if (attributes.name === "br") { return createElement(Br, props, children) }
    if (attributes.name === "div") { return createElement(Div, props, children) }
    if (attributes.name === "span") { return createElement(Span, props, children) }
    if (attributes.name === "link") { return createElement(Link, props, children) }
    if (attributes.name === "a") { props.attributes.classicLink = "true"; return createElement(Link, props, children) }
    if (attributes.name === "container") { return createElement(Container, props, children) }
    if (attributes.name === "grid") { return createElement(Grid, props, children) }
    if (attributes.name === "flex") { return createElement(Flex, props, children) }
    if (attributes.name === "space") { return createElement(Space, props, children) }
    if (attributes.name === "tabs") { return createElement(Tabs, props, children) }
    if (attributes.name === "accordions") { return createElement(Accordions, props, children) }
    if (attributes.name === "label") return createElement(Label, props, children);
    if (attributes.name === "text") return createElement(Etext, props, children);
    if (attributes.name === "divider") return createElement(Divider, props, children);
    if (attributes.name === "badge") { return createElement(Badge, props, children) }
    if (attributes.name === "floatbutton") { return createElement(FloatButton, props, children) }
    if (attributes.name === "buttonsgroup") { return createElement(ButtonsGroup, props, children) }
    if (attributes.name === "button") { return createElement(Button, props, children) }
    if (attributes.name === "form") { return createElement(Form, props, children) }
    if (attributes.name === "icon") { return createElement(Icon, props, children) }
    if (attributes.name === "steps") { return createElement(Steps, props, children) }
    if (~["input", "autocomplete"].indexOf(attributes.name)) { return createElement(Input, props, children) }
    if (attributes.name === "textarea") {
      props.attributes.type = (props.attributes.type || "").replace((/textarea|input|autocomplete|search|number/igm), "") + " textarea";
      return createElement(Input, props, children);
    }
    if (attributes.name === "search") {
      props.attributes.type = (props.attributes.type || "").replace((/textarea|input|autocomplete|search|number/igm), "") + " search";
      return createElement(Input, props, children);
    }
    if (~["inputnumber", "numberinput"].indexOf(attributes.name)) {
      props.attributes.type = (props.attributes.type || "").replace((/textarea|input|autocomplete|search|number/igm), "") + " number";
      return createElement(Input, props, children);
    }
    if (attributes.name === "cascader") { return createElement(Cascader, props, children) }
    if (attributes.name === "checkbox") { return createElement(Checkbox, props, children) }
    if (attributes.name === "radio") { return createElement(Radio, props, children) }
    if (attributes.name === "select") { return createElement(Select, props, children) }
    if (attributes.name === "segmented") { return createElement(Segmented, props, children) }
    if (attributes.name === "datepicker") { return createElement(DatePicker, props, children) }
    if (~["switch", "switcher"].indexOf(attributes.name)) { return createElement(Switch, props, children) }
    if (attributes.name === "transfer") { return createElement(Transfer, props, children) }
    if (attributes.name === "avatar") { return createElement(Avatar, props, children) }
    if (attributes.name === "calendar") { return createElement(Calendar, props, children) }
    if (attributes.name === "modal") { return createElement(Modal, props, children) }
    if (attributes.name === "aggrid") { return createElement(AGgrid, props, children) }
    if (attributes.name === "upload") { return createElement(Upload, props, children) }
    if (~["image", "img"].indexOf(attributes.name)) { return createElement(Image, props, children) }
    if (attributes.name === "tree") { return createElement(Tree, props, children) }
    if (attributes.name === "list") { return createElement(List, props, children) }
    if (attributes.name === "canvas") { return createElement(Canvas, props, children) }
    if (attributes.name === "chart" || attributes.name === "chartjs") { return createElement(Chart, props, children) }
    if (attributes.name === "iframe") { return createElement(Iframe, props, children) }
    if (~["reactgridlayout", "ReactGridLayout", "reactGridLayout"].indexOf(attributes.name)) { return createElement(ReactGridLayout, props, children) }
    if (attributes.name === "style") { return createElement(UserStyle, props, children) }
    if (attributes.name === "jodit" || attributes.name === "richtexteditor" || attributes.name === "RichTextEditor") { return createElement(Jodit, props, children) }

    if (~["html", "md", "markdown"].indexOf(attributes.name)) {
      props.attributes.type = attributes.name;
      return createElement(HTMLMDviewer, props);
    }

    if (~["drawer", "offcanvas"].indexOf(attributes.name)) { return createElement(Drawer, props, children) }
    if (attributes.name === "docviewer") { return createElement(Docviewer, props, children) }
    if (attributes.name === "approval") { return createElement(Approval, props, children) }
    if (attributes.name === "chat") { return createElement(Chat, props, children) }
    if (attributes.name === "guacamole") { return createElement(GuacamoleViewer, props, children) }

    return (<Fragment key={attributes.key} />);
  }
};

export default uigen;
